var $ = require('jquery');

require('../../Widgets/ui/slidingItem');

module.exports.name = 'slidingItem';
module.exports.init = function slidingItem() {
    $(function (){
        var $elements = $('.js-slidingItem');

        if ($elements.length > 0 && typeof $elements['slidingItem'] === 'function') {
            $elements['slidingItem']();
        }
    });
};

